import { Navigate } from "react-router-dom";
import { ROUTES_CONSTANTS } from "../../../constants/routesConstants";
import { usePermissions } from "../../../hooks/permissions/usePermissions";

const PermissionRoute = ({ children, requiredPermissions, requireAll = false }) => {
  const { hasAnyPermission, hasAllPermissions } = usePermissions();

  const isAllowed = requireAll
    ? hasAllPermissions(requiredPermissions)
    : hasAnyPermission(requiredPermissions);

  if (!isAllowed) {
    return <Navigate to={ROUTES_CONSTANTS.DASHBOARD} replace />;
  }

  return children;
};

export default PermissionRoute;